import axios from '../../config/axios';
import store from '../../config/store';

/**
 * 仅仅 判断是否vip
 * @returns
 */
export async function isVip () {
  return new Promise((resolve, reject) => {
    axios.get('/webApi/v3/account/vipInfo').then(resp => {
      let vipInfo = resp.data
      if (vipInfo && vipInfo.highestVip && (vipInfo.highestVip.vipLevel === 'GOLD' || vipInfo.highestVip.vipLevel === 'SILVER')) {
        console.log('是vip')
        resolve()
      } else {
        console.log('不是vip')
      }
    })
  });
}

/**
 * 获取VIP
 * @returns
 */
export async function getVip () {
  return new Promise((resolve, reject) => {
    axios.get('/webApi/v3/account/vipInfo').then(resp => {
      let vipInfo = resp.data
      resolve(vipInfo && vipInfo.highestVip)
    })
  });
}

/**
 * 获取VIP
 * @returns
 */
export async function isGoldVip () {
  return new Promise((resolve, reject) => {
    axios.get('/webApi/v3/account/vipInfo').then(resp => {
      let vipInfo = resp.data
      resolve((vipInfo && vipInfo.highestVip && vipInfo.highestVip.vipLevel) === 'GOLD')
    })
  });
}

/**
 *
 * @returns 判断是否是vip  如果不是会让购买
 */
export async function checkVip () {
  return new Promise((resolve, reject) => {
    axios.get('/webApi/v3/account/vipInfo').then(resp => {
      let vipInfo = resp.data
      if (vipInfo && vipInfo.highestVip && (vipInfo.highestVip.vipLevel === 'GOLD' || vipInfo.highestVip.vipLevel === 'SILVER')) {
        console.log('是vip')
        resolve()
      } else {
        console.log('不是vip')
        store.commit('showPriceDialog', '3003');
      }
    })
  });
}



// WEBPACK FOOTER //
// ./src/assets/js/app.js